<label class="label-field">
  {{displayText}}
  <span *ngIf="isMandatory" class="flag-required">*</span>
  <img class="dst-icon common-img-icon ml-imgtext" src="assets/images/info-blue.svg" alt="tooltip"
    tooltipClass="tooltipInfo" [placement]="displayPosition" draggable="false" [ngbTooltip]="tipContent" />
</label>
<ng-template #tipContent>{{content}}</ng-template>